import type { SVGProps } from "react";

/** Umriss des Sterns aus dem Design (24er-Raster). */
const STAR_PATH =
  "M5.82808 20.995L12.0001 17.75L18.1581 20.995L16.9791 14.122L21.9791 9.25495L15.0791 8.25495L11.9931 2.00195L8.90708 8.25495L2.00708 9.25495L7.00708 14.122L5.82808 20.995Z";

/** Linke Haelfte desselben Sterns, fuer halbe Bewertungen. */
const HALF_STAR_PATH =
  "M5.82808 20.995L12.0001 17.75L11.9931 2.00195L8.90708 8.25495L2.00708 9.25495L7.00708 14.122L5.82808 20.995Z";

type StarIconProps = {
  /** `full` gefuellt, `half` links gefuellt, `empty` nur Umriss. */
  fill?: "full" | "half" | "empty";
} & SVGProps<SVGSVGElement>;

/** Stern in `currentColor`, damit die Farbe per `text-*` kommt. */
export const StarIcon = ({ fill = "full", ...props }: StarIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      d={STAR_PATH}
      fill={fill === "full" ? "currentColor" : "none"}
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    {fill === "half" && (
      <path
        d={HALF_STAR_PATH}
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    )}
  </svg>
);
